<template>
  <page class="bg-color">
    <div class="tips">电子发票将发送到您提交的电子邮箱</div>
    <input class="email-input" v-model="email" type="text" placeholder="请填写电子邮箱">
    <div class="send-emails" @click="invoiceToEmail">发送</div>
  </page>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      email: ''
    }
  },
  computed: {},
  methods: {
    invoiceToEmail() {
      // const email = this.email
      // const queryData = this.$route.query
      // // eslint-disable-next-line no-useless-escape
      // if (/^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/.test(email)) {
      //   this.$service.invoiceToEmail({
      //     email: email,
      //     orderSn: queryData.orderSn,
      //     invoiceId: queryData.invoiceId.split(',')
      //   }).then(() => {
      //     let second = 2
      //     this.$toast.success({
      //       message: '发送成功！',
      //       forbidClick: true
      //     })
      //     const timer = setInterval(() => {
      //       second--
      //       if (!second) {
      //         clearInterval(timer)
      //         // 手动清除 Toast
      //         this.$router.back(-1)
      //       }
      //     }, 1000)
      //   })
      // } else {
      //   this.$toast('请输入正确的邮箱！')
      // }
    }
  },
  created() {}
}
</script>

<style lang="stylus" scoped>
.tips
  line-height 44px
  height 44px
  background #ffffff
  padding 0 15px
  font-size 14px
  color #333333
.email-input
  width 325px
  height 20px
  line-height 20px
  border-radius 5px
  background #fff
  font-size 14px
  padding 5px 10px
  margin 10px auto 0
  display block
.send-emails
  background #FC4C00
  border-radius 5px
  font-size 16px
  text-align center
  color #ffffff
  height 44px
  line-height 44px
  width 335px
  margin 50px auto 0
</style>
